module.exports = __webpack_public_path__ + "img/ico-reporting.6bc60fd5.svg";